import React from 'react'
import FilterIcon from 'components/icons/FilterIcon'
import styled, { css } from 'styled-components'
import { COLORS } from 'theme/index'
import Flex from 'components/Flex'
import { Dropdown, Badge, Tooltip } from 'antd'
import { FONT } from 'theme/font'
import { CloseCircleFilled } from '@ant-design/icons'

export const FilterFlex = styled(Flex)`
  width: 100%;
`
export const FilterText = styled.p`
  margin-bottom: 0;
  margin-left: 10px;
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
  white-space: nowrap;
  flex-shrink: 0;
`
export const StyledDropdown = styled(Dropdown)`
  width: 100%;
  cursor: pointer;
  height: 50px;
  padding-left: 10px;
  border-right: 1px solid ${COLORS.GREY_T_90};
  border-left: 1px solid ${COLORS.GREY_T_90};
  ${props =>
    props.hideBorder &&
    css`
      border-left: unset;
      border-right: 1px solid ${COLORS.GREY_T_90};
    `}
`

const FlexWrap = styled(Flex)`
  width: ${props => props.width ?? '67%'};
  position: ${props => props.position};
`

const FilterDiv = ({
  overlayMenu,
  label = 'Filter',
  trigger = 'click',
  open = false,
  setOpen,
  onOpenChange,
  width,
  position = 'relative',
  hideBorder,
  filterCount = 0,
  onClearFilters,
}) => {
  return (
    <FlexWrap width={width} position={position} id="filter-dropDown">
      <StyledDropdown
        overlay={overlayMenu}
        trigger={[trigger]}
        open={open}
        onClick={() => setOpen(true)}
        onOpenChange={onOpenChange}
        getPopupContainer={() => document.getElementById('filter-dropDown')}
        hideBorder={hideBorder}
      >
        <FilterFlex centerVertically onClick={e => e.preventDefault()}>
          <FilterIcon />
          <FilterText>{label}</FilterText>
          {filterCount > 0 && (
            <Badge
              count={filterCount}
              size="small"
              style={{ marginLeft: 6, backgroundColor: '#ff4d4f' }}
            />
          )}
          {filterCount > 0 && (
            <Tooltip title="Clear Filters">
              <CloseCircleFilled
                style={{ marginLeft: 10, color: '#ff4d4f', fontSize: 16, cursor: 'pointer', transition: 'transform 0.15s ease' }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.3)' }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)' }}
                onClick={e => { e.stopPropagation(); onClearFilters && onClearFilters() }}
              />
            </Tooltip>
          )}
        </FilterFlex>
      </StyledDropdown>
    </FlexWrap>
  )
}

export default FilterDiv
